import $ from "jquery";
import Mustache from 'mustache';

var GPPYComments = {
    init: function() {
        if ($('.gppy-project-comments').length) {
            GPPYComments.readComments();
            $('.gppy-project-comments-new a.btn').click(GPPYComments.addComment);
        }
    },

    readComments: function() {
        var project_id = $('[project_id]').eq(0).attr('project_id');

        Promise.all([
            Promise.resolve($.get('/snippets/projectCommentsTemplates')),
            Promise.resolve($.get('/api/getprojectcomments?project_id=' + project_id))
        ]).then(GPPYComments.renderComments);
    },

    renderComments: function(results) {
        var template = results[0];
        var rendered = Mustache.render(template, results[1]);
        $('.gppy-project-comments-list').html(rendered);
    },

    addComment: function () {
        var project_id = $('[project_id]').eq(0).attr('project_id');
        var text = $('.gppy-project-comments-new textarea').val();
        var data = {
            project_id: project_id,
            text: text
        };

        Promise.resolve($.post('/api/addprojectcomment',data)).
            then(GPPYComments.readComments);
    }
}

$('document').ready(GPPYComments.init);

